import script from "./NewStaff.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewStaff.vue?vue&type=script&setup=true&lang=ts"

import "./NewStaff.vue?vue&type=style&index=0&id=5e8478be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8478be"]])

export default __exports__